export const MAP_TOOLTIP_WIDTH = "200px";
